import React from 'react';
import { useEffect } from 'react';
import { Grid, Modal, Stack } from '@mui/material';
import '../../../../resources/styling/App.scss';
import InsightsLoader from '../../InsightsLoader';
import { Box, margin } from '@mui/system';
import { Alert } from '@mui/material';
import surveyTemplateService from '../../../../services/api/insights/surveyTemplateService';
import { Button, Snackbar } from '@mui/material';
import { config } from '../../../../utils/config';
import AddEditSurvey from './AddEditSurvey';
import { AppButton } from '../../../../resources/styling';
import { OutlineButton } from '../../../../resources/styling/appStyle';
import { set } from 'lodash';
import { templateHasTag } from '../../../../utils/templateTags';

const mandy = '#F76D57';
const colors = ['pink', 'blue', 'green', 'yellow', 'purple', 'orange'];
const images = ['checkbox', 'radio', 'text', 'rating'];

export default function TemplateList({
  selectedTag,
  selectedTemplate,
  setSelectedTemplate,
}) {
  const [templates, setTemplates] = React.useState([]);
  const [allTemplates, setAllTemplates] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [showEdit, setShowEdit] = React.useState(false);
  const [status, setStatus] = React.useState({
    open: false,
    message: '',
    type: 'success',
  });
  const [showConfirm, setShowConfirm] = React.useState(false);

  useEffect(() => {
    setLoading(true);
    surveyTemplateService
      .getAllTemplatesForAdmin()
      .then((res) => {
        if (res) {
          setTemplates(res);
          setAllTemplates(res);
        } else {
          setTemplates([]);
          setAllTemplates([]);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const renderEditModal = () =>
    showEdit && (
      <AddEditSurvey
        doneEdit={setShowEdit}
        template={selectedTemplate}
        updateAfterEdit={updateAfterEdit}
      />
    );

  const renderConfirmModal = () => (
    <Modal
      open={showConfirm}
      onClose={() => setShowConfirm(false)}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
        }}
      >
        <h3>Are you sure you want to delete this template?</h3>
        <Stack direction='row' spacing={2} marginTop={2}>
          <OutlineButton
            variant='contained'
            className='cancel-btn'
            onClick={() => {
              setSelectedTemplate(null);
              setShowConfirm(false);
            }}
          >
            Cancel
          </OutlineButton>
          <AppButton
            color={mandy}
            onClick={() => {
              setShowConfirm(false);
              deleteTemplate(selectedTemplate.id);
            }}
          >
            Delete
          </AppButton>
        </Stack>
      </Box>
    </Modal>
  );

  useEffect(() => {
    setLoading(true);
    let filteredTemplates = allTemplates;
    if (selectedTag) {
      filteredTemplates = allTemplates.filter((template) =>
        templateHasTag(template, selectedTag.tag)
      );
    }
    setTemplates(filteredTemplates);

    setLoading(false);
  }, [selectedTag]);

  const updateAfterEdit = (template) => {
    if (allTemplates.findIndex((x) => x.id === template.id) > -1) {
      const newTemplates = templates.map((t) => {
        if (t.id === template.id) {
          return template;
        } else {
          return t;
        }
      });
      setTemplates([...newTemplates]);
    } else {
      setTemplates([...templates, template]);
    }
  };
  const updateAfterDelete = () => {
    const newTemplates = templates.filter(
      (temp) => temp.id !== selectedTemplate.id
    );
    setTemplates([...newTemplates]);
  };

  const deleteTemplate = () => {
    surveyTemplateService.deleteTemplate(selectedTemplate.id).then(() => {
      updateAfterDelete();
      setSelectedTemplate(null);
      setStatus({
        open: true,
        message: 'Template deleted successfully',
        type: 'success',
      });
    });
  };

  return (
    <Box className='question-bank-container'>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        variant='filled'
        open={status.open}
        autoHideDuration={5000}
        onClose={() => setStatus({ ...status, open: false })}
      >
        <Alert severity={status.type} sx={{ width: '100%' }} variant='filled'>
          {status.message}
        </Alert>
      </Snackbar>
      {loading ? (
        <InsightsLoader />
      ) : templates.length > 0 ? (
        <>
          {renderEditModal()}
          <h2>{selectedTag?.tag}</h2>
          <div className='bank-questions'>
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className='template-list'>
                  <ul>
                    {templates.map((template, index) => (
                      <li key={index}>
                        <div className='template'>
                          <div className='template-header relative'>
                            <div
                              className={`${
                                colors[index >= 5 ? index % 5 : index]
                              } inner-padding relative template-width`}
                            >
                              <img
                                src={`${
                                  config.BASE_URL_Insights
                                }/Artifact/download?fileName=temp-${
                                  images[
                                    index > 3
                                      ? index % 5 > 3
                                        ? 0
                                        : index % 5
                                      : index
                                  ]
                                }.png`}
                                alt={images[index > 3 ? index % 3 : index]}
                              />
                            </div>
                            <div className='template-overlay'>
                              <Button
                                variant='contained'
                                className='use-template-btn'
                                onClick={() => {
                                  setShowConfirm(true);
                                  setSelectedTemplate(template);
                                }}
                              >
                                Delete template
                              </Button>
                              <Button
                                variant='contained'
                                onClick={() => {
                                  setSelectedTemplate(template);
                                  setShowEdit(true);
                                }}
                                className='preview-btn'
                              >
                                Edit template
                              </Button>
                            </div>
                          </div>

                          <div className='template-content'>
                            <h4>{template.name}</h4>
                          </div>

                          <div className='template-footer'>
                            {template.surveyQuestions?.length} questions
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </Grid>
            </Grid>
          </div>
        </>
      ) : selectedTag == null ? (
        <Alert severity='info' style={{ width: '100%' }}>
          Select a tag to view templates.
        </Alert>
      ) : (
        <Alert severity='info' style={{ width: '100%' }}>
          No templates added under this tag.
        </Alert>
      )}
      {renderConfirmModal()}
    </Box>
  );
}
